import React, { useState } from 'react'
import _lowerCase from 'lodash/lowerCase.js'
import { updateUrlParams } from './allProductTypesReducer'
export default function Filters(props) {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const {
    sortData,
    isLoading,
    classOptions,
    assertsOptions,
    productOptions,
    selected,
    searchInput,
    tableRowData,
  } = props

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const onClassDropdownChange = (filterName, value) => {
    let _selected = selected
    if(filterName === 'productType' && selected[filterName]?.includes(value)) {
      _selected.class = []
      updateUrlParams('class', _selected.class)
    }

    if (selected[filterName]?.includes(value)) {
      _selected[filterName] = selected[filterName].filter((i) => i !== value)
    } else {
      _selected[filterName].push(value)
    }
    updateUrlParams(filterName, _selected[filterName])
    sortData({ selected: _selected })
  }

  const onClearFilter = () => {
    toggleFilter()
    sortData({
      selected: {
        assetClass: [],
        productType: [],
        class: [],
      },
    })
    updateUrlParams('assetClass')
    updateUrlParams('productType')
    updateUrlParams('class')
  }

  const renderCol = (heading, options, filterName) => {
    let filterOptions = Object.keys(options)
      .filter((i) => i !== null && i !== undefined)
      .map((i) => ({ label: options[i], value: i }))
    if (filterName === 'class') {
      filterOptions = filterOptions?.sort((a, b) => a.value - b.value)
    }

    const renderSubcol = (colData, isSecond) =>
      colData.length < 1 ? null : (
        <div className={isSecond ? 'u-paddingLeft4gu' : ''}>
          {colData?.map((itm) => (
            <div key={itm.value} className="u-flex u-flexAlignItemsCenter">
              <div className="Checkbox">
                <input
                  type="checkbox"
                  id={`checkbox_${itm.value}`}
                  data-qa-automation={`checkbox_${itm.value}`}
                  className="Checkbox-button u-posRelative"
                  data-analytics={`filter-checkbox`}
                  checked={selected[filterName]?.includes(itm.value)}
                  value={itm.value}
                  onChange={() => onClassDropdownChange(filterName, itm.value)}
                />
                <label
                  htmlFor={`checkbox_${itm.value}`}
                  className="Checkbox-label u-margin0"
                >
                  <div className="u-textNoWrap">{itm.label}</div>
                </label>
              </div>
            </div>
          ))}
        </div>
      )
    return filterOptions?.length < 1 ? null : (
      <div className="u-paddingHoriz7gu u-paddingTop4gu">
        <div className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-textColorBrandDark">
          {heading}
        </div>
        <div className="u-flex">
          {renderSubcol(filterOptions?.slice(0, 8), false)}
          {renderSubcol(filterOptions?.slice(8), true)}
        </div>
      </div>
    )
  }

  const onInputChange = (value) => {
    sortData({ searchInput: value })
  }

  const getFilterCount = () => {
    return Object.keys(selected).reduce((p, n) => p + selected[n]?.length, 0)
  }

  let classFilterOptions = classOptions
  if (selected.productType?.length > 0) {
    classFilterOptions = tableRowData.reduce(
      (p, n) =>
        n.class?.length > 0 && selected.productType.includes(n.fundType)
          ? { ...p, [n.class]: [n.fundClass] }
          : p,
      {}
    )
  }

  return (
    <div className="u-lg-flex u-md-flex u-paddingTop3gu">
      {!isLoading && (
        <>
          <div className="u-lg-flexGrow1 u-md-flexGrow1 u-paddingBottom4gu">
            <div className="u-bgColorLight">
              <button
                onClick={toggleFilter}
                className="Button Button-filter u-paddingVert1gu u-paddingHoriz4gu u-posRelative u-sizeFull"
                data-analytics="simple-entry-component-body-filter-dropdown-btn"
                data-qa-automation="filter-dropdown-btn"
              >
                <div className="u-flex u-flexAlignItemsCenter ">
                  <span className="u-textSizeMsrp5 MutualFunds-filterButton arrow Icon--material u-textSizeMsrp2">
                    {isFilterOpen ? 'expand_less' : 'expand_more'}
                  </span>
                  <h2 className="u-textSizeMsrp1 u-paddingLeft3gu u-textBold u-textColorBrandDark">
                    Filters
                  </h2>
                  <div
                    className="u-textSizeMsrp1 u-marginLeft2gu"
                    data-qa-automation="filter-applied-count"
                  >
                    ({getFilterCount()} applied)
                  </div>
                </div>
              </button>
              {isFilterOpen && (
                <div
                  className="u-boxShadow2 u-bgColorLight u-posAbsolute"
                  style={{ zIndex: 352 }}
                >
                  <div className="u-lg-flex u-md-flex u-paddingVert1gu">
                    {renderCol('Product Type', productOptions, 'productType')}
                    {renderCol('Asset class', assertsOptions, 'assetClass')}
                    {renderCol('Class', classFilterOptions, 'class')}
                  </div>
                  <div className="u-paddingVert4gu u-paddingHoriz7gu">
                    <button
                      className="Button Button--primary Button--small"
                      data-tracking="view-results"
                      data-qa-automation="viewResults"
                      onClick={toggleFilter}
                    >
                      View Results
                    </button>
                    <button
                      className="Button Button--tertiary Button--small u-marginLeft3gu"
                      data-tracking="clear-filters"
                      data-qa-automation="clearFilters"
                      onClick={onClearFilter}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="u-lg-flexGrow1 u-md-flexGrow1 u-paddingBottom4gu">
            <div className="u-posRelative u-sm-marginLeft0 u-marginLeft4gu">
              <span
                className="Icon--material input-search-icon u-posAbsolute Icon--filter-search product-landing-search-filter"
                aria-hidden="true"
              >
                &#xE8B6;
              </span>
              <input
                onChange={(e) => onInputChange(e.currentTarget.value)}
                type="text"
                placeholder="Find a Product"
                className="Input Input--withIcon Icon--before MutualFunds-searchField u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0"
                data-qa-automation="search-input-field"
                value={searchInput}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
